<template>
  <div class="login-page login-3">
    <div class="site-wrapper">
      <div class="login-box">
        <div class="box-wrapper">
          <div class="logo-main">
            <a href="/admin">
              <img
                src="/assets/img/cash_logo_vertical.png"
                alt="Cash Now Logo">
            </a>
          </div>
          <router-view></router-view>
          <!-- <div class="page-copyright">
            © 2020 Cash Now
            <div>Initiated by<strong>&nbsp;<a href="https://craterapp.com/">Crater</a></strong> - Powered by <strong><a href="https://softpyramid.com/">Soft Pyramid</a></strong></div>
          </div> -->
        </div>
      </div>
      <div class="content-box">
        <h1>{{ $t('layout_login.short_term_finance') }}<br>
          {{ $t('layout_login.made_simple') }}<br>
        </h1>
        <p>
          {{ $t('layout_login.cashNow_help') }}<br>
          {{ $t('layout_login.invoicing_financial_platform') }}<br>
        </p>

        <div class="content-bottom"/>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  export default {
    watch: {
      $route: 'onRouteChange'
    },
    mounted() {
      this.setLayoutClasses()
    },
    methods: {
      setLayoutClasses() {
        let body = $('body')
        body.removeClass()
        body.addClass('login-page login-1 skin-crater')
      },
      onRouteChange() {
        $('body').removeClass('login-page')
      }
    },

  }
</script>
